import React from "react";
import "./CustomNavbar.scss";
import { Navbar, Nav, Container } from "react-bootstrap";
import { AiFillInstagram, AiFillFacebook, AiFillYoutube } from "react-icons/ai";
import logo from "../../../assets/img/logo-fulcrum.png";

const CustomNavbar = () => {
  return (
    <Navbar
      id="navbar"
      expand="lg"
      collapseOnSelect
      className="navbar"
      variant="light"
    >
      <Container>
        <Navbar.Brand href="#home">
          <img id="logo" src={logo} alt="logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse
          id="responsive-navbar-nav"
          className="justify-content-end"
        >
          <Nav className="linksContainer me-auto">
            <Nav.Link href="#nosotros">Nosotros</Nav.Link>
            <Nav.Link href="#proyectos">Proyectos</Nav.Link>
            <Nav.Link href="#videos">Videos</Nav.Link>
            {/* <Nav.Link href="#experiencia">Experiencias 360°</Nav.Link> */}
            <Nav.Link href="#contacto">Contacto</Nav.Link>
            <Nav.Link
              target="_blank"
              href="https://caminopatagon.blogspot.com/"
            >
              Blog
            </Nav.Link>
          </Nav>
          <Nav>
            <div id="navbarSocials">
              <a
                className="socialLink"
                target="_blank"
                href="https://www.instagram.com/fulcrumg_/"
              >
                <AiFillInstagram />
              </a>
              <a
                className="socialLink"
                target="_blank"
                href="https://web.facebook.com/fulcrumg"
              >
                <AiFillFacebook />
              </a>
              <a
                className="socialLink"
                target="_blank"
                href="https://www.youtube.com/@fulcrumgparcelascoyhaique"
              >
                <AiFillYoutube />
              </a>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export { CustomNavbar };
